import { useMutation, useQueryClient } from '@tanstack/react-query';

import { uploadProjectFile as uploadProjectFileAPI } from '@/api/v4/project-files.api';
import { QueryKey } from '@/config/query-client';

import { projectIdState } from '../../project.state';
import { useAtomValue } from 'jotai';

export const useUploadProjectFile = () => {
  const queryClient = useQueryClient();
  const projectId = useAtomValue(projectIdState);

  const mutation = useMutation({
    mutationFn: uploadProjectFileAPI,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.ProjectFiles, projectId],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivities],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivitiesCount],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.ProjectActionsInfo, projectId],
      });
    },
    onError: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.ProjectFiles, projectId],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.ProjectActionsInfo, projectId],
      });
    },
  });

  const uploadProjectFile = (files: File[]) => {
    if (!projectId) return;

    return mutation.mutateAsync({ projectId, files });
  };

  return {
    uploadProjectFile,
    isError: mutation.isError,
  };
};
